define([], function() {
	
	var Fraud = {
			
		call : function(successCallback){
		
			if(typeof(fraudStatic) === 'undefined'){
				successCallback();
			} else {		
				if(!fraudStatic.enabled){
					successCallback();
				}else{	
					_cc.push(['cag', successCallback]);
				}
			}
		}

	}
	
	if (typeof window.COSTCO === 'undefined') {
		window.COSTCO = new Object();
	}
	window.COSTCO.Fraud = Fraud;
	return Fraud;
});


// WEBPACK FOOTER //
// ./js/checkout/fraud.js